import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { LgvSnapshotHelper } from '../../core/core.module';

@Component({
    selector: 'lus-current-lien-widget',
    templateUrl: './current-lien-widget.component.html',
    styleUrls: ['./current-lien-widget.component.scss'],
    //changeDetection: ChangeDetectionStrategy.OnPush
})
export class CurrentLienWidgetComponent implements OnInit {
    @Input() currentLienWidgetData: any[];
    currentLien = 0;
    constructor(public SSHlpr: LgvSnapshotHelper,) { }

    ngOnInit(): void {
    }

    showLien(index: number) {
        this.currentLien = index;
    }

    showTooltip() {

    }

}
